import { Button } from 'primereact/button';
import { usePlanningWizard } from '../PlanningWizardContext';

/**
 * Placeholder body for steps that don't apply to the selected counselling type
 * (Angular "No X" cards with plain Previous/Next). Angular sameContentTemplate.
 */
const NoStepPlaceholder = ({ message }: { message: string }) => {
  const { activeIndex, nextPage, previousPage } = usePlanningWizard();

  return (
    <div className="card p-4">
      <div className="row">
        <div className="col">
          <b>{message}</b>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          {activeIndex > 0 && (
            <Button
              type="button"
              icon="pi pi-angle-left"
              label="Previous"
              className="p-button-danger"
              onClick={previousPage}
            />
          )}
        </div>
        <div className="col-6 text-end">
          <Button
            type="button"
            icon="pi pi-angle-right"
            iconPos="right"
            label="Next"
            className="p-button-success"
            onClick={nextPage}
          />
        </div>
      </div>
    </div>
  );
};

export default NoStepPlaceholder;
